import { createCacheStore } from '@lib/utils/cache';
import { DepartmentService } from '@api/DepartmentService';

/** Cached DepartmentService.getTraits(departmentId) reads. */
export const traitsCache = createCacheStore(
    'department/traits',
    DepartmentService.getTraits,
);

/** Drops the cached traits of a department (after trait mutations). */
export const invalidateTraits = (departmentId: string): void => {
    traitsCache.invalidate(departmentId);
};

/** Drops all cached trait data (department switch, full clears). */
export const invalidateTraitData = (): void => {
    traitsCache.invalidateAll();
};
